import { render, staticRenderFns } from "./PublishingChannels.vue?vue&type=template&id=c62dc982&"
import script from "./PublishingChannels.vue?vue&type=script&lang=js&"
export * from "./PublishingChannels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports